import React, { useState } from 'react';
import { NavMenu, List, Popover, Text, Bubble } from 'tea-component';
import SvgIcon from '@/pages/home/components/SvgIcon';
import { getLocale, useIntl } from 'umi';
import { LANGUAGE_CN } from '@/pages/home/_config/config';
import {
  changeURLStatic,
  getDefaultDBIPath,
} from '@/pages/home/utils/urlConfig';
import { getLanguage } from '@home/utils/common';
import moment from 'moment';
import classNames from 'classnames';

export default function NavListItem(props: any) {
  const { item, subSelect, select, clickSubMenu, clickMenu } = props;
  // 切换语言触发组件刷新
  const { formatMessage } = useIntl();
  const local = getLocale();

  // 子菜单显示
  const [visible, setVisible] = useState(false);

  const { useNewStyle, bubbleMessageId, bubbleIntroMessageId } = item;

  const handleOpen = (item: any) => {
    const { href } = item;
    // const config = navListConfig[rbac];
    // const { path } = config;
    changeURLStatic(href);
  };

  const handleNavListClick = (item: any) => {
    if (clickMenu instanceof Function) {
      if (select !== item?.rbac) {
        clickMenu(item?.rbac);
      }
    }
    if (item?.rbac === 'intelligence') {
      // 在情报点击搜索时再点击情报的情况；或在情报点击情报默认跳到mobileGames
      let dbiUrl = getDefaultDBIPath();
      if (select !== item?.rbac) {
        // 情报需要判断跳转到Following还是手游，所以后端链接传参判断；不要重复点击
        // 后端返回的链接是intelligence_detail开头，我们全都替换成了新风格链接
        dbiUrl = `/intelligence?fromHeaderClick=true`;
      }
      handleOpen({ ...(item || {}), href: dbiUrl });
    } else {
      handleOpen(item);
    }
  };
  const handleSubNavListClick = (subItem: any, fromParent = false) => {
    if (!fromParent) {
      setVisible(false);
    }
    handleOpen(subItem);
  };

  const nameKey = local === LANGUAGE_CN ? 'title_cn' : 'name';

  return (
    <NavMenu.Item
      onClick={() => {
        handleNavListClick(item);
      }}
    >
      {item.children && item.children.length > 0 ? (
        <Popover
          visible={visible}
          onVisibleChange={(visible) => setVisible(visible)}
          placement="bottom-start"
          trigger={'hover'}
          overlayClassName="dba-nav-menu-overlay"
          // trigger={'click'}
          overlay={
            // List 要放在循环外面的
            <div className={`mavdropdown-box ${item.name=='Studio Hub'?'mavdropdown-box-width':''}`}>
              <List type="option" className="mavdropdown">
                {item.children?.map((subItem: any) => (
                  <Bubble
                    key={subItem.rbac}
                    dark
                    arrowPointAtCenter
                    placement="right"
                    placementOffset={20}
                    overlayClassName="dba-nav-menu-overlay"
                    content={
                      subItem.bubbleIntroMessageId ? (
                        <>
                          {formatMessage({ id: subItem.bubbleIntroMessageId })}
                          <br />
                          {subItem.bubbleMessageId
                            ? formatMessage({ id: subItem.bubbleMessageId })
                            : ''}
                        </>
                      ) : null
                    }
                  >
                    <List.Item
                      key={subItem.rbac}
                      className={classNames(
                        subItem.rbac === subSelect
                          ? 'mavdropdown-action'
                          : 'mavdropdown-item',
                        { 'mavdropdown--no-icon': !subItem.subIcon && subItem.type !== 'studio' },
                      )}
                      onClick={(evt) => {
                        clickSubMenu?.(subItem.rbac);
                        handleSubNavListClick(subItem);
                        evt.stopPropagation();
                      }}
                    >
                      {subItem.type === 'studio' ? (
                        <img className="dropdown-icon" src={subItem.imgIcon} style={{ borderRadius: '5px' }}/>
                      ) : subItem.subIcon ? (
                        <SvgIcon
                          className="dropdown-icon"
                          type={subItem.subIcon}
                        />
                      ) : null}
                      <Text className="dropdown-text">
                        {subItem[nameKey] || subItem.name}
                      </Text>
                    </List.Item>
                  </Bubble>
                ))}
              </List>
            </div>
          }
        >
          <div>
            <MenuItem select={select} item={item} />
          </div>
        </Popover>
      ) : (
        <Bubble
          dark
          arrowPointAtCenter
          placement="bottom"
          placementOffset={20}
          overlayClassName="dba-nav-menu-overlay"
          content={
            bubbleIntroMessageId ? (
              <>
                {formatMessage({ id: bubbleIntroMessageId })}
                <br />
                {bubbleMessageId && !useNewStyle
                  ? formatMessage({ id: bubbleMessageId })
                  : ''}
              </>
            ) : null
          }
        >
          <div>
            <MenuItem select={select} item={item} />
          </div>
        </Bubble>
      )}
    </NavMenu.Item>
  );
}

const MenuItem = (props: any) => {
  const { select, item } = props;
  const local = getLocale();
  const nameKey = local === LANGUAGE_CN ? 'title_cn' : 'name';
  const today = moment();

  const isWithinTipDate =
    !!item.tipExpiredDate &&
    today.isBetween(
      moment(item.tipExpiredDate.start, 'YYYY-MM-DD'),
      moment(item.tipExpiredDate.end, 'YYYY-MM-DD').endOf('day'), // 设置结束时间为当天的结束
      undefined,
      '[]', // 包含边界
    );
  // tipImg 在选中/未选中两种状态都展示，所以修饰类与 select 状态无关
  const hasActiveTipImg = isWithinTipDate && !!item.tipImg;

  return (
    <div
      className={classNames(
        select === item.rbac ? 'lay-nav-action' : 'lay-nav-item',
        { 'lay-nav-item--with-tip-img': hasActiveTipImg },
      )}
    >
      {/* <SvgIcon
      className="item-icon"
      type={select === item.rbac ? item.actionIcon : item.icon}
    /> */}
      <span>{item[nameKey] || item.name}</span>
      {item.children && item.children.length > 0 ? (
        <div className="arrow-icon" />
      ) : null}
      {isWithinTipDate &&
        (item.tipImg ? (
          <TipsImg item={item} />
        ) : item.tipEn && item.tipCn && select !== item.rbac ? (
          <Tips item={item} />
        ) : null)}
    </div>
  );
};

const TipsImg = (props: any) => {
  const { item } = props;
  return <img className="lay-nav-tip-img" src={item.tipImg} alt="new" />;
};

const Tips = (props: any) => {
  const { item } = props;
  const local = getLocale();
  const isCn = local === LANGUAGE_CN;

  return (
    <div className={classNames('lay-nav-tip', {'dbh-nav-tip-cn':isCn})}>
      <span>{getLanguage(isCn,item.tipCn,item.tipEn)}</span>
    </div>
  );
};
